var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart3Dark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 68,
    viewBox: "0 0 292 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 68V8L285 8.00001V68H6Z",
    fill: "url(#paint0_linear_715_825)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H285",
    stroke: "#0DD15B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 4,
    fill: "#0DD15B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 7,
    r: 4,
    fill: "#0DD15B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 7,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 7,
    r: 4,
    fill: "#0DD15B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 7,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 7,
    r: 4,
    fill: "#0DD15B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 7,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 66.5V11",
    stroke: "#6F6D7C",
    strokeDasharray: "2 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99 66.5V10.5",
    stroke: "#6F6D7C",
    strokeDasharray: "2 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192 66.5V11.5",
    stroke: "#6F6D7C",
    strokeDasharray: "2 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285 67V11.5",
    stroke: "#6F6D7C",
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_825",
    x1: 145.59,
    y1: 8,
    x2: 145.59,
    y2: 72.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D80FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E65EF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart3Dark);
export default __webpack_public_path__ + "static/media/chart3Dark.2ccc0111065e4807c843212e958ab8f1.svg";
export { ForwardRef as ReactComponent };